import { VolumeUp as VolumeUpIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';

const AlertIcon = ({ fontSize = undefined }) => <VolumeUpIcon style={{ fontSize }} />;

AlertIcon.propTypes = {
    fontSize: PropTypes.string,
};

export default AlertIcon;
